// extracted by mini-css-extract-plugin
export default {"PrepareScoreTitle":"iStyles_PrepareScoreTitle__hKkyD","PrepareScoreSubTitle":"iStyles_PrepareScoreSubTitle__pkDEI"};